import styled, { css } from 'styled-components';
import theme from 'styles/theme';

export const TextMedium = styled.div`
  padding: 41px 0 18px;
  width: 100%;
  font-size: 1.6rem;
  font-weight: 500;
  line-height: 2.4rem;
  color: ${theme.color.black};
  text-align: center;
`;

export const ChildText = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  margin: 20px 0 0;
`;

export const ChildTextContent = styled.div`
  width: 100%;
  font-size: 1.3rem;
  font-weight: 500;
  text-align: left;
  line-height: 2.1rem;
  color: ${theme.color.black};
`;

export const TextareaDiv = styled.div`
  position: relative;
`;

export const TextareaField = styled.textarea`
  width: 100%;
  margin: 23px 0 0;
  padding: 14px;
  line-height: 2.2rem;
  font-size: 1.3rem;
  font-weight: 500;
  border: ${props =>
    props.showMessage ? `1px solid ${theme.borderColor.blue};` : 'transparent;'}
  border-radius: 10px;
  background: ${theme.backgroundColor.form};
  color: ${theme.color.black};
  
  resize: none; // 사이즈 고정

  ${props => {
    if (props.uppercase) {
      return css`
        text-transform: uppercase;
      `;
    }
  }}

  &:focus {
    border: 1px solid ${theme.borderColor.blue};
  }

  ::placeholder {
    color: ${theme.color.placeholder};
  }

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  position: relative;
`;

export const InputLabel = styled.div`
  position: absolute;
  z-index: 10;
  bottom: 10px;
  right: 20px;
  color: ${theme.color.placeholder};
  font-size: 1.3rem;
  line-height: 2rem;
`;

export const Icon = styled.span`
  margin: 5px;
`;

export const QnAImgDiv = styled.div`
  position: relative;
  width: 25%;
`;

export const QnAImg = styled.img`
  width: 100%;
  padding: 0 1px;
  border-radius: 5px;
`;

export const QnAImgDeleteBtn = styled.button`
  position: absolute;
  color: white;
  z-index: 10;
  top: 5px;
  right: 5px;
`;
